import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../motion";
import { HEALTH_STEPS } from "../../content";

export function HealthCheck() {
  return (
    <section id="health-check" data-testid="health-check-section" className="grain relative bg-cherry-deep text-ivory">
      <div className="relative z-[2] mx-auto max-w-7xl px-5 py-14 sm:px-8 sm:py-20 lg:py-24">
        <SectionHead
          dark
          eyebrow="Featured service"
          title="AML Health Check"
          intro="An independent review of your existing AML arrangements."
        />

        <div className="mt-8 grid gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:gap-16">
          <div>
            <Reveal>
              <div className="max-w-2xl space-y-4 text-base leading-relaxed text-ivory/80">
                <p>
                  I review your firm&rsquo;s risk assessment, policies and procedures against relevant regulatory
                  requirements and supervisory guidance.
                </p>
                <p>
                  You&rsquo;ll receive a written report identifying gaps, areas for improvement and recommended next
                  steps, prioritised according to risk.
                </p>
              </div>
            </Reveal>

            <Reveal delay={0.15}>
              <a
                href="#sample-report"
                data-testid="health-check-sample-cta"
                className="group mt-7 inline-flex items-center gap-2 rounded-full bg-ivory px-7 py-3 text-sm font-medium text-cherry-deep transition-colors duration-200 hover:bg-blush"
              >
                View Sample Report
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
              </a>
            </Reveal>
          </div>

          <div>
            <Reveal delay={0.1}>
              <p className="text-xs font-medium uppercase tracking-[0.24em] text-gold">How it works</p>
            </Reveal>
            <ol className="mt-4 divide-y divide-ivory/15 border-t border-ivory/15">
              {HEALTH_STEPS.map((step, i) => (
                <Reveal as="li" key={step.title} delay={0.05 * i}>
                  <div data-testid={`health-step-${i}`} className="grid gap-1 py-4 sm:grid-cols-[3.5rem_1fr] sm:gap-3">
                    <p className="font-display text-xl italic text-gold">{String(i + 1).padStart(2, "0")}</p>
                    <div>
                      <h3 className="font-display text-lg text-ivory">{step.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-ivory/70">{step.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}
